import useEventListener from "./use-event-listener";

export const useScroll = <T extends Document | HTMLElement = HTMLDivElement>(
  handler: () => void,
  element?: T
): void => {
  useEventListener("scroll", handler, element);
};
